




































import { maxLength, required } from '@/utils/ValidationUtil'
import Vue from 'vue'

import { Component } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class ShowBaja extends Vue {
  private dialog = false

  private valid = true
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  private motivo = ''

  private rules = {
    required,
    maxLength750: maxLength(750),
  }

  baja() {
    if (this.$refs.form.validate()) {
      this.$emit('baja', this.motivo)
      this.closeDialog()
    }
  }
  closeDialog() {
    this.dialog = false
  }

  openDialog() {
    this.motivo = ''
    this.$refs.form.reset()
    this.$refs.form.resetValidation()
    this.dialog = true
  }
}
